import { MarkerTypeGeneral } from 'types/markerTypes/location-markers-type.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { NA_VALUE } from 'utilities/weather-station/location.js';
import { MarkerComponentType } from './utils.js';

export type TemperatureItem = {
  key: MarkerComponentType.TempDisplay;
  index: string;
  tempLabel: string;
};

export const hasTempLabel = ({ value, label, type }: ILocationSummary): TemperatureItem | undefined => {
  if (type === MarkerTypeGeneral.Urban && isNotNullOrUndefined(value.temp)) {
    const tempLabel = value.temp === NA_VALUE ? NA_VALUE : `${value.temp}°`;
    return {
      key: MarkerComponentType.TempDisplay,
      index: `${type}-${label}`,
      tempLabel,
    };
  }
  return undefined;
};

export const TemperatureLabel = ({ tempLabel }: TemperatureItem) => <span className="u-pL-xs">{tempLabel}</span>;
